import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { t } from "../../i18n";

const API_URL = process.env.REACT_APP_API_URL || "https://b.supchats.com";

export default function TestWidgetPage({ token }) {
  const { agentId } = useParams();
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token || !agentId) {
      setLoading(false);
      setError(t("Access denied"));
      return;
    }
    const load = async () => {
      try {
        const res = await axios.get(`${API_URL}/agents`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });
        const agents = res.data || [];
        const found = agents.find((a) => String(a.id) === String(agentId));
        if (!found) {
          setError(t("Agent not found"));
          return;
        }
        setAgent(found);
      } catch (e) {
        setError(e.response?.status === 401 ? t("Please sign in to test the widget") : t("Failed to load agent"));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [token, agentId]);

  useEffect(() => {
    if (!agent) return;
    const script = document.createElement("script");
    script.src = `${API_URL}/api/widget-loader/${agent.id}?test=1`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      try {
        if (script.parentNode) script.parentNode.removeChild(script);
      } catch (_) {}
      document.querySelectorAll("[id^='supchats-spa-widget-']").forEach((el) => el.remove());
    };
  }, [agent]);

  if (loading) {
    return (
      <div className="test-widget-page">
        <div className="test-widget-header">
          <span>{t("Loading...")}</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="test-widget-page">
        <div className="test-widget-header">
          <Link to="/agents">← {t("Back to agents")}</Link>
        </div>
        <div className="test-widget-error">
          <p>{error}</p>
          <Link to="/agents">{t("Back to agents")}</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="test-widget-page">
      <div className="test-widget-header">
        <Link to="/agents">← {t("Back to agents")}</Link>
        <span className="test-widget-title">
          {t("Test widget")}: {agent.name}
        </span>
      </div>
      <p className="test-widget-hint">{t("Chat with the widget in the bottom-right corner.")}</p>
    </div>
  );
}
